import type { ChatMessage } from "@stockline/shared/types/ai/chat-message"
import { CHAT_MESSAGE_TABLE } from "../../../lib/offline/resources/ai/chat-message/db"
import { useAISync } from "../providers/AISyncProvider"

export function useChatMessages(sessionId: string | null): ChatMessage[] {
  const { reactive } = useAISync()
  const results = reactive.useQuery<ChatMessage>(
    CHAT_MESSAGE_TABLE,
    sessionId ? { sessionId, orderBy: "position" } : { sessionId: "__none__" }
  )
  return sessionId ? results : []
}
